import { render, staticRenderFns } from "./HelpShop.vue?vue&type=template&id=517bd0b3&scoped=true&"
import script from "./HelpShop.vue?vue&type=script&lang=js&"
export * from "./HelpShop.vue?vue&type=script&lang=js&"
import style0 from "./HelpShop.vue?vue&type=style&index=0&id=517bd0b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517bd0b3",
  null
  
)

export default component.exports